module.exports = __webpack_public_path__ + "static/img/area_1.4f1c9e0d.svg";